import React from 'react';
import Layout from "../components/Layout";
import NavOne from "../components/NavOne";
import Footer from "../components/Footer";
import Marketplace from "../components/Marketplace";

const CoursesPage = () => {
    return (
        <Layout pageTitle="HiTech | Cổng giao dịch">
            <NavOne />
            <Marketplace />
            <Footer />
        </Layout>
    );
};

export default CoursesPage;
